import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Image,
  Card,
  Form,
  Tabs,
  Tab,
} from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { Large } from "../../stories/Button.stories";
import { Secondary } from "../../stories/Button.stories";
import { Info } from "../../stories/Button.stories";
import { Medium } from "../../stories/Input.stories";
import AuthService from "../../services/auth.service";
import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";
import ReactCodeInput from "react-verification-code-input";
import Modal from "react-bootstrap/Modal";
import SuccessCheck from "../../assets/images/successCheck.svg";
import ToastBlockContainer from "../../common/ToastBlockContainer";
import UserService from "../../services/user.service";
import "react-phone-input-2/lib/style.css";
import Loading from "../../common/Loading";

const SignUp = () => {
  let history = useHistory();
  const initialValues = {
    firstname: "",
    lastname: "",
    email: "",
    password: "",
  };
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [formCodeValues, setFormCodeValues] = useState("");
  const [regUserUUID, setRegUserUUID] = useState("");
  const [formCodeErrors, setFormCodeErrors] = useState({});
  const [isCodeSubmit, setIsCodeSubmit] = useState(false);
  const [loadingCode, setLoadingCode] = useState(false);
  const [successToast, setSuccessToast] = useState(false);

  // code verification model
  const [showVerificationModel, setShowVerificationModel] = useState(false);
  const handleShowVerificationModelClose = () =>
    setShowVerificationModel(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };
  // Password toggle handler
  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormErrors(validate(formValues));
    setIsSubmit(true);
    setLoading(true);
  };

  const handleVerificationChange = (e) => {
    let codeValue = e;
    setFormCodeValues(codeValue);
  };
  const handleVerificationSubmit = (e) => {
    e.preventDefault();
    setFormCodeErrors(validateEmailCode(formCodeValues));
    setIsCodeSubmit(true);
    setLoadingCode(true);
  };

  const validateEmailCode = (values) => {
    setLoadingCode(false);
    const c_errors = {};
    if (values.length !== "6") {
      c_errors.msg = "Please enter valid verification code";
      c_errors.code = "Yes";
      window.scrollTo(0, 0);
      setSuccessToast(false);
      setShowToast(true);
      setToastMessage(c_errors.msg);
    }
    return c_errors;
  };
  useEffect(() => {
    // redirect to dashboard if already logged in
    let items = localStorage.getItem("UserDetails");
    if (items) {
      var stringify = JSON.parse(items);
      if (stringify) {
        //redirect to Login
        history.push("/family_selection");
      }
    }
    // reg. form submit
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      let data = {
        firstName: formValues.firstname,
        lastName: formValues.lastname,
        email: formValues.email.toLowerCase(),
        password: formValues.password,
      };

      // api call
      AuthService.register(data).then(
        (res) => {
          if (res) {
            if (res.status === 400) {
              const errors = {};
              errors.msg = res.data.error;

              setFormErrors(errors);
              window.scrollTo(0, 0);
              setSuccessToast(false);
              setShowToast(true);
              setToastMessage(errors.msg);
            } else {
              setRegUserUUID(res.user_id);
              setIsSubmit(false);

              //direct login after user successfully registered
              let dataVal = {
                email: formValues.email.toLowerCase(),
                password: formValues.password,
              };
              AuthService.login(dataVal).then(
                (res) => {
                  // profile api call
                  UserService.userProfile(res.data.uuid).then(
                    (response) => {
                      var entry = {
                        avatar: response.userData.avatar,
                        countryCode: response.userData.countryCode,
                        contactNumber: response.userData.contactNumber,
                        createdAt: response.userData.createdAt,
                        email: response.userData.email,
                        firstname: response.userData.firstName,
                        id: response.userData.id,
                        isActive: response.userData.isActive,
                        isContactVerified: response.userData.isContactVerified,
                        isEmailVerified: response.userData.isEmailVerified,
                        lastname: response.userData.lastName,
                        updatedAt: response.userData.updatedAt,
                        uuid: res.data.uuid,
                        displayId: response.userData.displayId,
                        //'accessToken': UserDetails.accessToken,
                      };

                      UserService.getImages().then((respo) => {
                        console.log(respo);
                        localStorage.setItem("defaultImgg", respo.defaultImgg);
                        localStorage.setItem(
                          "defaultusrImgg",
                          respo.defaultusrImgg
                        );
                        localStorage.setItem(
                          "supplierDefaultLogo",
                          respo.supplierDefaultLogo
                        );
                      });

                      localStorage.setItem(
                        "UserDetails",
                        JSON.stringify(entry)
                      );
                      UserService.getUserFamily(res.data.uuid).then(
                        (response) => {
                          // eslint-disable-next-line no-lone-blocks
                          {
                            response.usersFamilyData.length === 0
                              ? history.push({
                                  pathname: "/newcard_billing_details",
                                  familyList: "",
                                  inviteList: "",
                                  state: {
                                    planFullData,
                                  },
                                })
                              : response.usersFamilyData.length === 1 &&
                                response.usersFamilyData[0].inviteStatus ===
                                  "Onboarded"
                              ? history.push({
                                  pathname:
                                    "/dashboard/" +
                                    response.usersFamilyData[0].Family.uuid,
                                  familyList: "",
                                  inviteList: "",
                                })
                              : response.usersFamilyData[0].inviteStatus ===
                                "Acceptance Pending"
                              ? history.push({
                                  pathname: "/family_selection",
                                  familyList: "",
                                  inviteList: "",
                                })
                              : history.push({
                                  pathname: "/family_selection",
                                  familyList: "",
                                  inviteList: "",
                                });
                          }
                          setLoading(false);
                        }
                      );
                    },
                    () => {}
                  );
                },
                (error) => {
                  const errors = {};
                  if (error.response === undefined) {
                    errors.msg = "Connection timed out. Please try again later";
                    setFormErrors(errors);
                    window.scrollTo(0, 0);
                    setSuccessToast(false);
                    setShowToast(true);
                    setToastMessage(errors.msg);
                  } else {
                    errors.msg = error.response.data.error;

                    window.scrollTo(0, 0);
                    setSuccessToast(false);
                    setShowToast(true);
                    setToastMessage(errors.msg);
                    if (errors.msg) {
                      setFormErrors(errors);
                    }
                  }
                  setLoading(false);
                }
              );
            }
          } else {
          }
        },
        (error) => {
          const errors = {};
          errors.msg = error.response;

          window.scrollTo(0, 0);
          setSuccessToast(false);
          setShowToast(true);
          setToastMessage(errors.msg);
          if (errors.msg) {
            setFormErrors(errors.msg);
          }
          setLoading(false);
        }
      );
    } else {
      setLoading(false);
    }
    // email verification form submit
    if (Object.keys(formCodeErrors).length === 0 && isCodeSubmit) {
      let data = {
        code: formCodeValues,
      };
      // api call
      AuthService.verifyUserEmail(data, regUserUUID).then(
        (res) => {
          if (res.status === 400) {
            setLoadingCode(false);
            setShowVerificationModel(true);
            window.scrollTo(0, 0);
            setSuccessToast(false);
            setShowToast(true);
            setToastMessage(res.data.error);
          } else {
            setLoadingCode(false);
            setShowVerificationModel(false);
            setSuccessToast(true);
            setShowToast(true);
            setToastMessage("Email verified successfully");
            setTimeout(() => {
              history.push("/");
            }, 2000);
          }
        },
        (error) => {
          const errors = {};
          errors.msg = error.response;

          window.scrollTo(0, 0);
          setSuccessToast(false);
          setShowToast(true);
          setToastMessage(errors.msg);

          if (errors.msg) {
            setFormErrors(errors);
          }
          setLoadingCode(false);
        }
      );
    } else {
      setLoadingCode(false);
    }
  }, [formErrors, formCodeErrors]);

  const validate = (values) => {
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    if (!values.firstname) {
      errors.msg = "Please enter the required fields";
      errors.firstname = "Yes";
    }
    if (!values.lastname) {
      errors.msg = "Please enter the required fields";
      errors.lastname = "Yes";
    }
    if (!values.email) {
      errors.msg = "Please enter the required fields";
      errors.email = "Yes";
    } else if (!regex.test(values.email)) {
      errors.msg = "This is not a valid email format !";
      errors.email = "Yes";
    }

    if (!values.password) {
      errors.msg = "Please enter the required fields";
      errors.password = "Yes";
    } else {
      var alphanumerics = /^.{8,40}$/;
      if (!values.password.match(alphanumerics)) {
        errors.msg = "Please enter a valid password";
        errors.password = "Yes";
      }
    }
    return errors;
  };

  useEffect(() => {
    const setHeight = () => {
      const container = document.getElementById("containerVal");
      const container1 = document.getElementById("containerVal1");

      if (container) {
        container.style.minHeight = `${window.innerHeight}px`;
        container.style.height = "auto";
      }
      if (container1) {
        container1.style.minHeight = `${window.innerHeight}px`;
        container1.style.height = "auto";
      }
    };

    window.addEventListener("resize", setHeight);
    window.addEventListener("click", setHeight);

    setHeight(); // Initial height setup

    return () => {
      window.removeEventListener("resize", setHeight);
      window.removeEventListener("click", setHeight);
    };
  }, []);

  const queryParams = new URLSearchParams(window.location.search);
  const billingQuery = queryParams.get("billing");
  const planQuery = queryParams.get("plan");

  const getInitialBilling = () => {
    if (billingQuery === "monthly" || billingQuery === "yearly") {
      return billingQuery;
    }
    return "yearly";
  };

  const getInitialPlan = () => {
    if (planQuery) {
      const lower = planQuery.toLowerCase();
      if (lower === "single") return "Single";
      if (lower === "couple" || lower === "joint") return "Couple";
      if (lower === "family" || lower === "shared") return "Family";
    }
    return "Single";
  };

  const [accountPlanData, setAccountPlanData] = useState([]);
  const [isLoad, setIsLoad] = useState(true);
  const [activeTab, setActiveTab] = useState(getInitialBilling());
  const [activeTab1, setActiveTab1] = useState(getInitialPlan());
  const [planFullData, setPlanFullData] = useState();

  useEffect(() => {
    const apiUrl =
      "https://developmentapi.elderlylife.com/accountPlan/plan/list";

    fetch(apiUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json(); // Convert response to JSON
      })
      .then((data) => {
        // Modify the AccountPlanData array before setting it
        const updatedPlanData = data.AccountPlanData.map((plan) => {
          if (plan.renewalType === "yearly") {
            switch (plan.uniqueIdentifier) {
              case "single-yearly":
                return { ...plan, monthlyPrice: "4.17" };
              case "couple-yearly":
                return { ...plan, monthlyPrice: "5.83" };
              case "family-yearly":
                return { ...plan, monthlyPrice: "7.50" };
              default:
                return plan;
            }
          }
          return plan;
        });

        setAccountPlanData(updatedPlanData);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    setTimeout(() => {
      setIsLoad(false);
    }, 500);
  }, []);

  const handleSelect = (key) => {
    setActiveTab(key);
  };

  const handleSelect1 = (key) => {
    setActiveTab1(key);
  };

  useEffect(() => {
    for (let i = 0; i < accountPlanData.length; i++) {
      if (
        accountPlanData[i].name === activeTab1 &&
        accountPlanData[i].renewalType === activeTab
      ) {
        setPlanFullData(accountPlanData[i]);
      }
    }
  }, [activeTab, activeTab1, accountPlanData]);

  const planDescriptions = {
    Single: `An individual who needs support from a loved one or carer — whether it’s a parent supported by their family, or a carer helping someone live with clarity and peace of mind.`,

    Couple: `Two people aging together, such as partners, siblings, or lifelong friends, who want to support one another, with added backup from trusted family or carers when needed.`,

    Family: `Families, care teams, or close-knit households supporting multiple elderly loved ones, staying connected and prepared as a group.`,
  };

  return (
    <>
      <div>
        <ToastBlockContainer
          successToast={successToast}
          showToast={showToast}
          setShowToast={setShowToast}
          toastMessage={toastMessage}
        />
        <div className="container-fluid px-0 position-fixed top-0 w-100 h-100 overflow-auto">
          <Row className="mx-auto flex-column-reverse flex-lg-row">
            {/* left container  */}
            <Col lg="12" className="bg-white order-2 order-lg-1">
              <div
                className="d-lg-flex  text-white flex-column  mx-5 d-flex  justify-content-start pt-5 pt-lg-8"
                id="containerVal"
              >
                <div className="">
                  <Form className="login-form" onSubmit={handleSubmit}>
                    {/* 1st row */}
                    <Row className="mb-0">
                      <h1 className="mb-1 title-heading">
                        Create an account on Elderly Life
                      </h1>
                      <span className="mb-1 login-boarder"></span>

                      <p className="align-right">
                        <Link to="/" className="link-brd">
                          <span className="centre-link">
                            Already have an account? Login here
                          </span>
                        </Link>
                      </p>
                    </Row>
                    <Row>
                      <Col xxl="24">
                        {/* First Name  */}
                        <Form.Group className="mb-4" controlId="formBasicEmail">
                          <Form.Label
                            className={
                              formErrors.firstname ? "invalid-text" : ""
                            }
                          >
                            First name
                          </Form.Label>
                          <Medium
                            type="text"
                            errorClass={
                              formErrors.firstname ? "invalid-border" : ""
                            }
                            placeholder="John"
                            size="medium"
                            name="firstname"
                            value={formValues.firstname}
                            className={`form-control ${
                              formErrors.firstname ? "invalid-border" : ""
                            }`}
                            onChange={handleChange}
                            //(event) => this.handleUserInput(event)
                          />
                          <Form.Text
                            className={
                              formErrors.firstname ? "text-danger" : " "
                            }
                          >
                            This will be used as First name
                          </Form.Text>
                        </Form.Group>
                      </Col>
                      <Col xxl="24">
                        {/* Last Name  */}
                        <Form.Group className="mb-4" controlId="formBasicEmail">
                          <Form.Label
                            className={
                              formErrors.lastname ? "invalid-text" : ""
                            }
                          >
                            Last name
                          </Form.Label>
                          <Medium
                            type="text"
                            errorClass={
                              formErrors.lastname ? "invalid-input" : ""
                            }
                            placeholder="Walker"
                            size="medium"
                            name="lastname"
                            className={`form-control  ${
                              formErrors.lastname ? "invalid-border" : ""
                            }`}
                            value={formValues.lastname}
                            onChange={handleChange}
                          />
                          <Form.Text
                            className={
                              formErrors.lastname ? "text-danger" : " "
                            }
                          >
                            This will be used as Last name
                          </Form.Text>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col xxl="24">
                        {/* Email  */}
                        <Form.Group className="mb-4" controlId="formBasicEmail">
                          <Form.Label
                            className={formErrors.email ? "invalid-text" : ""}
                          >
                            Email
                          </Form.Label>
                          {/* <Form.Control type="email" placeholder="John@gmail.com" /> */}
                          <Medium
                            type="email"
                            errorClass={formErrors.email ? "invalid-input" : ""}
                            placeholder="John@gmail.com"
                            size="medium"
                            className={`form-control ${
                              formErrors.email ? "invalid-border" : ""
                            }`}
                            name="email"
                            value={formValues.email}
                            onChange={handleChange}
                          />
                          <Form.Text
                            className={formErrors.email ? "text-danger" : " "}
                          >
                            This will be used as Email
                          </Form.Text>
                        </Form.Group>
                      </Col>

                      <Col xxl="24">
                        {/* create password  */}
                        <Form.Group
                          className="mb-4"
                          controlId="formBasicPassword"
                        >
                          <Form.Label
                            className={
                              formErrors.password ? "invalid-text" : ""
                            }
                          >
                            Create Password
                          </Form.Label>
                          <InputGroup
                            className={
                              formErrors.password ? "invalid-border br-12" : ""
                            }
                          >
                            <FormControl
                              type={passwordShown ? "text" : "password"}
                              className={
                                formErrors.password ? "invalid-input" : ""
                              }
                              placeholder="Password"
                              size="medium"
                              name="password"
                              value={formValues.password}
                              onChange={handleChange}
                            />
                            <InputGroup.Text
                              className={
                                formErrors.password
                                  ? "invalid-input"
                                  : "pwd-icon"
                              }
                            >
                              <i
                                className={`fa ${
                                  passwordShown ? "fa-eye" : "fa-eye-slash"
                                } password-icon cursor-pointer`}
                                onClick={togglePassword}
                              />
                            </InputGroup.Text>
                          </InputGroup>
                          <Form.Text
                            className={
                              formErrors.password ? "text-danger" : " "
                            }
                          >
                            Your password should be of minimum 8 characters and
                            can contain alphanumerics
                          </Form.Text>
                        </Form.Group>
                      </Col>
                    </Row>

                    <div>
                      <Large
                        className="btn btn-primary w-100"
                        children="Sign Up"
                        size="largebtn"
                        variant="primary"
                        type=""
                        isLoading={loading ? "true" : "false"}
                        isDisabled={loading ? "true" : "false"}
                      />
                      {/* {loading && (
                        <span className="spinner-border spinner-border-sm"></span>
                      )} */}
                    </div>
                  </Form>
                </div>
              </div>
            </Col>

            {/* Right Container */}
            <Col lg="12" className="p-0 order-1 order-lg-2">
              <div
                className="d-flex align-items-start justify-content-center cont mx-1666 pt-5 pt-lg-8"
                id="containerVal1"
              >
                <div className="d-flex flex-column">
                  <div className="px-2 pt-2 pb-2">
                    <h3>Select the Support Plan that Meets Your Needs</h3>

                    <div className="d-flex flex-column gap-1 mt-4">
                      <span class="text-dark d-flex flex-row gap-1">
                        <span>&#10004; </span>
                        <span>Select monthly or annual billing</span>
                      </span>

                      <span class="text-dark d-flex flex-row gap-1">
                        <span>&#10004; </span>
                        <span>
                          Choose the plan based on how many people need support
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="w-100">
                    <div
                      className={`story-card subscription-cards mb-3 bg-white br-12`}
                      style={{
                        boxShadow: "rgba(0, 123, 255, 0.2) 0px 3px 8px",
                      }}
                    >
                      <div className="p-4 mt-4">
                        <div className="mb-4 fw-semibold bold-colour d-flex align-items-center justify-content-between new-billing-page">
                          <div className="text-center">
                            <span className="bg-primary rounded px-2 py-1 fs-14">
                              Select Billing
                            </span>
                            <Tabs
                              activeKey={activeTab}
                              id="uncontrolled-tab-example"
                              className="tab-container d-flex align-items-center fs-14 tab-leftOne mt-4"
                              style={{ border: "none" }}
                              onSelect={handleSelect}
                            >
                              <Tab
                                eventKey="yearly"
                                title="Annual"
                                className="tab-annual mb-0 "
                              ></Tab>
                              <Tab
                                eventKey="monthly"
                                title="Monthly"
                                className="tab-monthly mb-0 "
                              ></Tab>
                            </Tabs>
                          </div>

                          <div className="text-center">
                            <span className="bg-primary rounded px-2 py-1 fs-14">
                              Choose Plan
                            </span>
                            <Tabs
                              activeKey={activeTab1}
                              id="uncontrolled-tab-example"
                              className="tab-container d-flex align-items-center fs-14 tab-rightOne mt-4"
                              style={{ border: "none" }}
                              onSelect={handleSelect1}
                            >
                              <Tab
                                eventKey="Single"
                                title="Single"
                                className="tab-annual mb-0 "
                              ></Tab>
                              <Tab
                                eventKey="Couple"
                                title="Joint"
                                className="tab-annual mb-0 "
                              ></Tab>
                              <Tab
                                eventKey="Family"
                                title="Shared"
                                className="tab-monthly mb-0 "
                              ></Tab>
                            </Tabs>
                          </div>
                        </div>
                        {isLoad ? (
                          <div
                            className="d-flex flex-column"
                            style={{ height: "16rem" }}
                          >
                            <Loading />
                          </div>
                        ) : (
                          <div>
                            <div className="mb-3">
                              <h1>
                                {/* {planFullData && planFullData.name} */}
                                {planFullData === "Single"
                                  ? "Single"
                                  : planFullData.name === "Couple"
                                  ? "Joint"
                                  : planFullData.name === "Family"
                                  ? "Shared"
                                  : planFullData.name}{" "}
                                Support
                              </h1>
                              <div className="text-info lh-sm mb-0">
                                {planFullData.renewalType === "yearly" ? (
                                  <div>
                                    <p className="fs-36 fw-bold mb-1">
                                      £{planFullData.monthlyPrice}
                                    </p>
                                    <p className="small text-dark mb-1">
                                      per month
                                    </p>
                                    <p className="text-dark mb-2 mb-md-2">
                                      Billed annually as{" "}
                                      <span className="text-info fw-bold">
                                        £{planFullData.price}
                                      </span>
                                    </p>
                                  </div>
                                ) : (
                                  <div>
                                    <span className="fs-36 fw-bold">
                                      £{planFullData.price}
                                    </span>
                                    <div className="small text-dark mb-2 mb-md-2">
                                      per{" "}
                                      {planFullData.renewalType === "yearly"
                                        ? "year"
                                        : "month"}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <p className="mb-4 mt-4">
                                {planDescriptions[planFullData.name]}
                              </p>
                              {/* <div className="text-info fs-36 fw-bold">
                              <strong>
                                {planFullData && planFullData.Country.symbol}{" "}
                                {planFullData && planFullData.price}
                              </strong>
                            </div>
                            <div className="fw-semibold bold-colour">
                              {planFullData &&
                              planFullData.renewalType === "yearly"
                                ? "per year"
                                : "per month"}
                            </div> */}
                            </div>

                            <p className="fw-semibold bold-colour mb-2">
                              <span class="text-success me-2">&#10004;</span>
                              {planFullData &&
                              planFullData.availableSeats === 1 ? (
                                <span>
                                  {planFullData && planFullData.availableSeats}{" "}
                                  Main User
                                </span>
                              ) : (
                                <span>
                                  {planFullData && planFullData.availableSeats}{" "}
                                  Main Users
                                </span>
                              )}
                            </p>
                            <p className="fw-semibold bold-colour mb-2">
                              <span class="text-success me-2">&#10004;</span>
                              {planFullData &&
                              planFullData.availableSeats === 1 ? (
                                <span>
                                  {planFullData && planFullData.availableSeats}{" "}
                                  Support User
                                </span>
                              ) : (
                                <span>
                                  {planFullData && planFullData.availableSeats}{" "}
                                  Support Users
                                </span>
                              )}
                            </p>
                            <p className="fw-semibold bold-colour mb-2">
                              <span class="text-success me-2">&#10004;</span>
                              <span>Cancel any time</span>
                            </p>
                            <p className="fw-semibold bold-colour mb-0">
                              <span class="text-success me-2">&#10004;</span>
                              <span>No hidden costs</span>
                            </p>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="text-center mb-4">
                      <i
                        className="fas fa-smile"
                        style={{ color: "#d8d838" }}
                      ></i>
                      <div className="text-info fw-bold fs-14">
                        30 Days Free
                      </div>
                      <div className="mt-1 fs-14">
                        You won't be charged today. Cancel anytime – no stress,
                        no pressure
                      </div>
                      <div className="mt-1 fs-14">
                        Still unsure?
                        <a
                          className="text-reset fw-bold"
                          href="https://elderlylife.com/contact-us"
                          target="_blank"
                          rel="noreferrer"
                        >
                          {" "}
                          Contact Us
                        </a>{" "}
                        or visit our
                        <a
                          className="text-reset fw-bold"
                          href="https://elderlylife.com/plans"
                          target="_blank"
                          rel="noreferrer"
                        >
                          {" "}
                          Plans and Pricing{" "}
                        </a>
                        Page for more details.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      {/* verify email model */}
      <Modal
        show={showVerificationModel}
        onHide={handleShowVerificationModelClose}
        className="verification_modal"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="verifictaion-success-msg">
            <Row>
              <Col md="1" lg="1">
                <Image
                  className="hello-text-img my-0"
                  src={SuccessCheck}
                  alt="Check mark"
                  width="40px"
                />
              </Col>
              <Col md="10" lg="10" className="ml-3">
                <span>
                  Hurray!! Your Elderly Life account has been successfully
                  created
                </span>
              </Col>
            </Row>
          </div>
          <p className="my-4">
            <strong>
              We have sent a 6 digit verification code to your email.
            </strong>
          </p>
          <Form
            className="verification-form"
            onSubmit={handleVerificationSubmit}
          >
            <p className="mb-2">Verification Code</p>
            <ReactCodeInput
              value={formCodeValues}
              name="code"
              fields={6}
              onChange={handleVerificationChange}
              className={formCodeErrors.code ? "invalid-text" : ""}
            />
            <input type="hidden" name="regUser" value={regUserUUID} />

            <div className="align-center pt-4">
              <Secondary
                children="Submit Code"
                size="mediumbtn"
                variant="secondary"
                type=""
                buttonWidth="260px"
                font_Weight="600"
                isLoading={loadingCode ? "true" : "false"}
                isDisabled={loadingCode ? "true" : "false"}
              />
            </div>
          </Form>
          <div className="align-center py-3">
            <Link to="/">
              <Info
                children="Skip and Login"
                size="mediumbtn"
                variant="info"
                type=""
                buttonWidth="260px"
                font_Weight="600"
              />
            </Link>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SignUp;
